import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {
  getBaseUrlObNextGen,
  getObNextGenApiUrlLists,
  getObNextgenTagTypes,
  OB_NEXT_GEN_REDUCER_KEY,
} from '../constants/obNextGenConstants';

const { GET_APPLICATIONS } = getObNextGenApiUrlLists();
const { APPLICATION } = getObNextgenTagTypes();

/**
 * RTK Query API slice for OB NextGen related endpoints.
 * This slice is responsible for managing API calls and caching via Redux store.
 */
export const obNextGenApi = createApi({
  reducerPath: OB_NEXT_GEN_REDUCER_KEY, // Unique key for reducer registration
  baseQuery: fetchBaseQuery({
    baseUrl: getBaseUrlObNextGen(), // Dynamically resolves base URL
  }),
  tagTypes: [APPLICATION], // Optional: for cache invalidation with tags
  endpoints: (builder) => ({
    /**
     * GET - Fetch a paginated list of applications.
     */
    getApplications: builder.query<any, void>({
      query: () => GET_APPLICATIONS,
      // Optional: disable cache (uncomment if needed)
      // keepUnusedDataFor: 0,
      // refetchOnMountOrArgChange: true,
      providesTags: [APPLICATION], // Enables invalidation by tag
    }),

    // ------------------------------
    // EXAMPLES BELOW FOR REFERENCE ONLY
    // ------------------------------

    /**
     * POST - Create a new application (example)
     */
    // createApplication: builder.mutation<any, Partial<ApplicationType>>({
    //   query: (body) => ({
    //     url: '/idw/admin/applications',
    //     method: 'POST',
    //     body,
    //   }),
    //   invalidatesTags: [APPLICATION],
    // }),

    /**
     * PUT - Update an existing application (example)
     */
    // updateApplication: builder.mutation<any, { id: string; data: Partial<ApplicationType> }>({
    //   query: ({ id, data }) => ({
    //     url: `/idw/admin/applications/${id}`,
    //     method: 'PUT',
    //     body: data,
    //   }),
    //   invalidatesTags: [APPLICATION],
    // }),

    /**
     * DELETE - Delete an application (example)
     */
    // deleteApplication: builder.mutation<any, string>({
    //   query: (id) => ({
    //     url: `/idw/admin/applications/${id}`,
    //     method: 'DELETE',
    //   }),
    //   invalidatesTags: [APPLICATION],
    // }),
  }),
});

// Export the generated hooks for usage in components
export const { useGetApplicationsQuery } = obNextGenApi;

// NOTE:
// - Follow consistent naming: `use<EndpointName><Query/Mutation>`
// - You can export additional hooks as you add more endpoints above
